import { render, staticRenderFns } from "./addThesisProposal.vue?vue&type=template&id=30baf2f2&scoped=true"
import script from "./addThesisProposal.vue?vue&type=script&lang=js"
export * from "./addThesisProposal.vue?vue&type=script&lang=js"
import style0 from "./addThesisProposal.vue?vue&type=style&index=0&id=30baf2f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30baf2f2",
  null
  
)

export default component.exports